<template>
  <div>
    <el-page-header class="detail-head" @back="goBack" content="微信菜单详情"> </el-page-header>
    <el-divider></el-divider>
    <div class="detail-container">
      <el-scrollbar>
        <el-form class="detail-form" ref="mainForm" :model="entity" :rules="rules" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="编码" class="detail-form-item" prop="code">
                  <el-input size="medium" v-model="entity.code"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="名称" class="detail-form-item" prop="name">
                  <el-input size="medium" v-model="entity.name"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="父级菜单" class="detail-form-item">
                  <el-select class="detail-form-item-select" size="medium" v-model="entity.parentId" clearable>
                    <el-option v-for="item in parents" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="是否已发布" class="detail-form-item">
                  <el-radio-group v-model="entity.upload">
                    <el-radio disabled :label="true">是</el-radio>
                    <el-radio disabled :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="grid-content">
                <el-form-item label="地址" class="detail-form-item">
                  <el-input size="medium" v-model="entity.url"></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="创建人" class="detail-form-item">
                  <el-input size="medium" v-model="entity.creator" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="创建时间" class="detail-form-item">
                  <el-input size="medium" v-model="entity.createTime" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="修改人" class="detail-form-item">
                  <el-input size="medium" v-model="entity.modifier" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="修改时间" class="detail-form-item">
                  <el-input size="medium" v-model="entity.modifyTime" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="grid-content">
                <el-form-item label="备注" class="detail-form-item">
                  <el-input type="textarea" v-model="entity.remark"></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </el-scrollbar>
    </div>
    <el-divider class="detail-divider"></el-divider>
    <div class="detail-form-item-btns">
      <el-button v-if="edit" size="medium" class="detail-form-item-btn" type="primary" @click="save">保存</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="goBack">返回列表</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="reset">刷新</el-button>
    </div>
  </div>
</template>

<script lang="ts">
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import { WechatMenu } from "@/script/apps/wechat/entity/WechatEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { DictUtil } from "@/script/core/Dict";
import { WechatMenuService } from "@/script/apps/wechat/service/WechatMenuService";
import { ElMessage } from "element-plus";

@Options({})
export default class WechatMenuDetail extends BaseDetail {
  private parents: WechatMenu[] = [];

  private service = new WechatMenuService();

  public initData(): ServiceContext {
    return ServiceFactory.build(
      "biz_wechat_menu",
      "/wechat/menu",
      "/wechat/menu",
      this.service
    );
  }

  private rules = {
    code: [{ required: true, message: "请输入编码", trigger: "blur" }],
    name: [{ required: true, message: "请输入名称", trigger: "blur" }],
  };

  public newEntity() {
    const entity: WechatMenu = {};
    return entity;
  }

  protected initOptions() {
    super.initOptions();
    this.service.loadParentMenus(this.id, (data: any) => {
      this.parents = data;
    });
  }
}
</script>

<style lang="scss">
</style>
